import script from "./Primary.vue?vue&type=script&lang=ts&setup=true"
export * from "./Primary.vue?vue&type=script&lang=ts&setup=true"

import "./Primary.vue?vue&type=style&index=0&id=1c918ee9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c918ee9"]])

export default __exports__